"use client";

// Puts the `dark` class on <html> from the reader's own system setting, which is all the app was
// ever missing: globals.css has carried a complete `.dark` palette and the screens are written with
// `dark:` variants throughout, but nothing was there to switch it on.
//
// `system` is the default on purpose. A guest on a phone in night mode at 1am should get a dark
// screen without being asked, and staff on a bright front desk should not.
import { ThemeProvider as NextThemes } from "next-themes";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemes attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      {children}
    </NextThemes>
  );
}
